import api from './api';

export const listInvitationCodes = () =>
    api.get('/InvitationCode').then(r => r.data);

export const createInvitationCode = (payload) =>
    api.post('/InvitationCode', payload).then(r => r.data);

export const deleteInvitationCode = (id) =>
    api.delete(`/InvitationCode/${id}`).then(r => r.data);
